import axios, { type AxiosError } from "axios";

const BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "";

export const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

api.interceptors.request.use((cfg) => {
  cfg.headers["X-Request-ID"] =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2);
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError) => {
    const status = err.response?.status;
    const url = err.config?.url ?? "";

    // 401 na chronionych endpointach = sesja wygasła. /login ignorujemy.
    if (status === 401 && !url.includes("/login")) {
      window.dispatchEvent(
        new CustomEvent("auth:logout", { detail: { reason: "session_expired" } }),
      );
    }

    // 429 = rate-limit. Pokaż globalny toast (jeśli store dostępny) + reject normalnie.
    if (status === 429) {
      const retryAfter = err.response?.headers?.["retry-after"];
      const minutes = retryAfter ? Math.ceil(Number(retryAfter) / 60) : 15;
      window.dispatchEvent(
        new CustomEvent("api:rate-limit", {
          detail: { url, retryMinutes: minutes },
        }),
      );
    }

    return Promise.reject(err);
  },
);
